export default __webpack_public_path__ + "static/home-2-hero-bg-5cb469a5b0d206b0fef1be64d041adec.jpg";